import vPermissions from "./common/auth/v-permissions";
import vRoles from "./common/auth/v-roles";
// 统一导出
export default {
  install: (app: any) => {
    vPermissions(app);
    vRoles(app);
  },
};